<template>
<div class="chapter">
<div class="inner_page">
<p class="p9"><span class="t7">N</span><span class="t8">OVELS</span><span class="t7"> </span><span class="t8">BY</span></p>
<p class="p0"><span class="t10">J</span><span class="t7">OHN</span><span class="t10"> S</span><span class="t7">IMPSON</span></p>
<p class="p10"><span class="t7">Alex and Clayton</span></p>
<p class="p0"><span class="t7">Badges: An Anthology</span></p>
<p class="p0"><span class="t7">Def Con One</span></p>
<p class="p0"><span class="t7">Irish Winter</span></p>
<p class="p11"><span class="t7">Jack and Dave</span></p>
<p class="p0"><span class="t7">C</span><span class="t8">ONDOR</span><span class="t7"> O</span><span class="t8">NE</span></p>
<p class="p0"><span class="t7">Condor One</span></p>
<p class="p0"><span class="t7">Talons of the Condor</span></p>
<p class="p0"><span class="t7">Condor and Falcon</span></p>
<p class="p0"><span class="t7">Out of the Gilded Cage</span></p>
<p class="p11"><span class="t7">Condor and the Crown</span></p>
<p class="p0"><span class="t7">M</span><span class="t8">URDER</span><span class="t7"> M</span><span class="t8">OST</span><span class="t7"> G</span><span class="t8">AY</span></p>
<p class="p0"><span class="t7">Murder Most Gay</span></p>
<p class="p0"><span class="t7">Task Force</span></p>
<p class="p0"><span class="t7">The Rent Boy Murders</span></p>
<p class="p0"><span class="t7">Murder on a Queen</span></p>
<p class="p10"><span class="t9">E</span><span class="t11">B</span><span class="t9">OOKS</span><span class="t11"> </span><span class="t9">BY</span><span class="t11"> </span></p>
<p class="p11"><span class="t11">J</span><span class="t9">OHN</span><span class="t11"> S</span><span class="t9">IMPSON</span></p>
<p class="p0"><span class="t7">The Barracks Affair</span></p>
<p class="p0"><span class="t7">The Beach House</span></p>
<p class="p0"><span class="t7">Carpathian Intrigue</span></p>
<p class="p0"><span class="t7">Fairy Tale</span></p>
<p class="p0"><span class="t7">Four Grooms and a Queen</span></p>
<p class="p0"><span class="t7">The Ghosts of Stanton Hall</span></p>
<p class="p0"><span class="t7">Hard Streets</span></p>
<p class="p0"><span class="t7">Naval Maneuvers</span></p>
<p class="p0"><span class="t7">Pirate Booty</span></p>
<p class="p0"><span class="t7">School of Discipline</span></p>
<p class="p0"><span class="t7">Wolf’s Head Inn</span></p>
<p class="p12"><span class="t7">All available from</span></p>
<p class="p0"><span class="t11">D</span><span class="t9">REAMSPINNER</span><span class="t11"> P</span><span class="t9">RESS</span></p>
<p class="p0"><span class="t7">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?244dd2e8